import {
  FEED,
  getFeedBackAssociados,
  IgetFeedBackAssociados,
} from "#/api/associadosFeedBackLogin";
import { getAgenciaContaComissionado } from "#/api/getAgenciaConta";
import { getValorDecodeBase64 } from "#/contextProver/ContextProverServices";
import { IInputFormatRemoveLetters, IVerifyAccountProductsFeed } from "./model";

const regexRemoveLetters = (event: React.ChangeEvent<HTMLInputElement>) => {
  const regexRemoveLetters = /\D/g;
  return event.target.value.replace(regexRemoveLetters, "");
};

export const inputFormatRemoveLetters = ({
  event,
  setInput,
  setRegex,
  isLimitValueWithSpace = false,
}: IInputFormatRemoveLetters) => {
  setInput(event.target.value);
  const value = regexRemoveLetters(event);
  if (isLimitValueWithSpace) {
    const newValue = limitValueWithSpace(value) as string;
    setRegex(newValue);
  } else {
    setRegex(value);
  }
};

export const limitValueWithSpace = (value: string) => {
  if (value.length > 5) {
    return value.slice(0, 5) + " " + value.slice(5);
  }
  return value;
};

export const verificarElegibilidade = async ({
  conta,
  cooperativa,
  codigoComissionado,
  documento,
}: IgetFeedBackAssociados) => {
  try {
    const capitalIntegralizado = await getFeedBackAssociados({
      conta,
      cooperativa,
      codigoComissionado,
      documento,
      accountFeedback: FEED.CAPITAL_INTEGRALIZADO,
    });
    if (capitalIntegralizado.data.feedback != null) {
      return FEED.CAPITAL_INTEGRALIZADO;
    }
  } catch (e) {
    throw e;
  }
};

export const getAgenciaContaUserByInput = async ({
  cooperativaInput,
  contaInput,
  setAgencyAccountCommissioned,
  documento,
}: IVerifyAccountProductsFeed) => {
  const { data } = await getAgenciaContaComissionado({ documento });
  const agenciaConta = data.contas.find(
    (item) =>
      getValorDecodeBase64(item.agencia) === cooperativaInput &&
      getValorDecodeBase64(item.conta) === contaInput
  );
  if (agenciaConta) {
    setAgencyAccountCommissioned(agenciaConta);
    return agenciaConta;
  } else {
    return undefined;
  }
};
